import { render, staticRenderFns } from "./TireVehicleFitment.vue?vue&type=template&id=de2f19ae"
import script from "./TireVehicleFitment.vue?vue&type=script&lang=ts"
export * from "./TireVehicleFitment.vue?vue&type=script&lang=ts"
import style0 from "./TireVehicleFitment.vue?vue&type=style&index=0&id=de2f19ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports